import 'css-chunksrc/client/scenes/wbs/project/styles.scss';export default {
  "project": "_project_u9gaw_1",
  "name": "_name_u9gaw_8",
  "hovered": "_hovered_u9gaw_9",
  "zone": "_zone_u9gaw_21",
  "icon": "_icon_u9gaw_28",
  "toggleArrowBox": "_toggleArrowBox_u9gaw_35",
  "toggleArrow": "_toggleArrow_u9gaw_35",
  "openedIcon": "_openedIcon_u9gaw_51",
  "details": "_details_u9gaw_55",
  "detail": "_detail_u9gaw_55",
  "main": "_main_u9gaw_75",
  "wrapper": "_wrapper_u9gaw_98",
  "status": "_status_u9gaw_118",
  "contextualMenu": "_contextualMenu_u9gaw_124",
  "allocated": "_allocated_u9gaw_133",
  "displayedContextualMenu": "_displayedContextualMenu_u9gaw_139"
};